module.exports = __webpack_public_path__ + "static/media/black-back-icon.9db05b40.svg";